/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Platform API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  GetPlatformV1Users200,
  GetPlatformV1UsersIdPathParameters,
  PatchPlatformV1UsersIdBody,
  PatchPlatformV1UsersIdPathParameters,
  PlatformUser,
  PostPlatformV1UsersBody,
  PostPlatformV1UsersIdResendWelcomePathParameters
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary All platform users
 */
export const getPlatformV1Users = (

 options?: SecondParameter<typeof customInstance<GetPlatformV1Users200>>,) => {
      return customInstance<GetPlatformV1Users200>(
      {url: `/platform/v1/users`, method: 'GET'
    },
      options);
    }
  /**
 * The account has no password until the link is used (7 days). Only owners can create owners
 * @summary Create a platform user and email a set-password link
 */
export const postPlatformV1Users = (
    postPlatformV1UsersBody: BodyType<PostPlatformV1UsersBody>,
 options?: SecondParameter<typeof customInstance<PlatformUser>>,) => {
      return customInstance<PlatformUser>(
      {url: `/platform/v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPlatformV1UsersBody
    },
      options);
    }
  /**
 * @summary Get a platform user
 */
export const getPlatformV1UsersId = (
    { id }: GetPlatformV1UsersIdPathParameters,
 options?: SecondParameter<typeof customInstance<PlatformUser>>,) => {
      return customInstance<PlatformUser>(
      {url: `/platform/v1/users/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * You cannot change your own role or status; the last active owner cannot be demoted or disabled; only owners change owners. Disabling ends the user's sessions
 * @summary Change a platform user's name, role or status
 */
export const patchPlatformV1UsersId = (
    { id }: PatchPlatformV1UsersIdPathParameters,
    patchPlatformV1UsersIdBody: BodyType<PatchPlatformV1UsersIdBody>,
 options?: SecondParameter<typeof customInstance<PlatformUser>>,) => {
      return customInstance<PlatformUser>(
      {url: `/platform/v1/users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchPlatformV1UsersIdBody
    },
      options);
    }
  /**
 * @summary Send the set-password link again to a user who has not set one
 */
export const postPlatformV1UsersIdResendWelcome = (
    { id }: PostPlatformV1UsersIdResendWelcomePathParameters,
 options?: SecondParameter<typeof customInstance<PlatformUser>>,) => {
      return customInstance<PlatformUser>(
      {url: `/platform/v1/users/${id}/resend-welcome`, method: 'POST'
    },
      options);
    }
  export type GetPlatformV1UsersResult = NonNullable<Awaited<ReturnType<typeof getPlatformV1Users>>>
export type PostPlatformV1UsersResult = NonNullable<Awaited<ReturnType<typeof postPlatformV1Users>>>
export type GetPlatformV1UsersIdResult = NonNullable<Awaited<ReturnType<typeof getPlatformV1UsersId>>>
export type PatchPlatformV1UsersIdResult = NonNullable<Awaited<ReturnType<typeof patchPlatformV1UsersId>>>
export type PostPlatformV1UsersIdResendWelcomeResult = NonNullable<Awaited<ReturnType<typeof postPlatformV1UsersIdResendWelcome>>>
